import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { CurrentWorkflowService } from '../current-workflow/current-workflow.service';

@Injectable({
  providedIn: 'root',
})
export class ConnectedService {
  public isLoggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(
    false
  );

  topOptions = [
    {
      id: 'smenu_second',
      routerLink: '/dashboard',
      icon: 'gauge',
      active: true,
      prime: false,
    },
    {
      id: 'smenu_third',
      routerLink: '/workflow-builder',
      icon: 'code-fork',
      active: false,
      prime: false,
      command: () => this.checkWorkFlowBuilder(),
    },
  ];

  constructor(private currentWorkflowService: CurrentWorkflowService) {}

  checkWorkFlowBuilder() {
    const elements = document.getElementsByClassName(
      'create-work-component-header'
    );
    if (elements.length != 0) {
      this.currentWorkflowService.isCreateWorkflowActionHit.next(true);
    }
  }
}
